import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  ADMINS(state, gycwarehouse) {
    state.cached = gycwarehouse
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchAdmins(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/manager/admin/documents/${query}`).then((response) => {
      const request = response.data
      context.commit('ADMINS', request)
      return request
    })
  },

  // fetchAdminOptions(context, query) {
  //   query = query || ''
  //   return axios.options(`${serverUrl}/manager/warehouses/${query}`).then((response) => {
  //     return response.data
  //   })
  // },

  fetchAdminDetail(context, payload) {
    return axios.get(`${serverUrl}/manager/admin/documents/${payload.id}/`).then((response) => {
      return response.data
    })
  },

  createUpdateAdmin(context, payload) {
    let promise = null
    if (payload.data.id){
      promise =  axios.put(`${serverUrl}/manager/admin/documents/${payload.data.id}/`, payload.data)
    }else {
      promise =  axios.post(`${serverUrl}/manager/admin/documents/`, payload.data)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deleteAdmin(context, payload) {
    let promise = null
    promise =  axios.delete(`${serverUrl}/manager/admin/documents/${payload.id}/`)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}